import React, { useState } from 'react';
import { Table, Form, Input, Select, Statistic, Button } from 'antd';
import { LikeOutlined, DislikeOutlined } from '@ant-design/icons';
const { Option } = Select;
var _ = require('lodash');

const columns = [
    {
        title: 'Parameter',
        dataIndex: 'parameter',
        width: 250,
    },
    {
        title: 'Administration Parameter',
        dataIndex: 'sub_parameter',
        render: text => {
            return <p>{text.split("<BR>").map(item => <div>{item}<br /></div>)}</p>
        },
    },
    {
        title: "Feedback",
        dataIndex: "feedback",
        width: 350,
        render: (_, record) => {
            if (record.disabled) {
                return <p>{record.selected_option}</p>
            }
            return <Form.Item
                name={record.key}
                rules={[{ required: true, message: "Please select" }]}
            >
                <Select defaultValue={record.score} disabled={record.disabled} onSelect={(score) => record.updateFunction(record.key, score)}>
                    {record.input_options.map(item => <Option value={item.score}>{item.option}</Option>)}
                </Select>
            </Form.Item>
        },
    },
    {
        title: 'Score',
        dataIndex: 'score',
        width: 200,
        align: "center",
        key: 'score',
    },
];
const parameters = [
    {
        key: 'on_time_shift',
        parameter: 'Time discipline',
        category: 'Discipline & Compliance',
        sub_parameter: 'Did the contractor start and finish work shift on time with proper work permit system, Toolbox talk and site readiness',
        input_options: [{ option: '>95% compliance', score: 4 }, { option: '86%-95% compliance', score: 3 }, { option: '76%-85% compliance', score: 2 }, { option: '70%-75% compliance', score: 1 }, { option: 'Less than 70% compliance', score: 0 }],
        score: 0,
        weight: 15,
        weighted_score: 0,
    },
    {
        key: 'worker_payment',
        parameter: 'Human resources',
        category: 'Discipline & Compliance',
        sub_parameter: 'Worker payment (Wage+ PF+ ESI)',
        input_options: [{ option: 'By 10th of every month', score: 4 }, { option: 'Between 10th to 15th of every month', score: 3 }, { option: 'Between 15th to 20th of every month', score: 2 }, { option: 'Between 20th to 30th of every month', score: 1 }, { option: 'Not paid in the month', score: 0 }],
        score: 0,
        weight: 25,
        weighted_score: 0,
    },
    {
        key: 'reporting',
        parameter: 'Reporting',
        category: 'Discipline & Compliance',
        sub_parameter: 'Release of Plan/ Schedule and MIS:<BR>1) Does the contractor prepare monthly plans based on the asking rate and front availability?<BR>2) Does the vendor release DPR/ WPR/ MPR as agreed with the project team/ PMC team?',
        input_options: [{ option: 'Both requirements fulfilled', score: 4 }, { option: 'Partial fulfilment of both the requirements', score: 3 }, { option: 'Only one requirement fulfilled', score: 2 }, { option: 'Partial fulfilment of one requirement', score: 1 }, { option: 'No requirement fulfilled', score: 0 }],
        score: 0,
        weight: 20,
        weighted_score: 0,
    },
    {
        key: 'amenities',
        parameter: 'Amenities for workers',
        category: 'Discipline & Compliance',
        sub_parameter: '1) Proper accommodation to workers<BR>2) Proper transportation to workers<BR>3) Proper PPEs to workers<BR>4) Proper on-site amenities to workers (Toilets, rest shed, snacks etc.)',
        input_options: [{ option: 'All 4 requirements fulfilled', score: 4 }, { option: '3 requirements fulfilled', score: 3 }, { option: '2 requirements fulfilled', score: 2 }, { option: '1 requirement fulfilled', score: 1 }, { option: 'No requirement fulfilled', score: 0 }],
        score: 0,
        weight: 25,
        weighted_score: 0,
    },
    {
        key: 'onsite_behaviour',
        parameter: 'On site behaviour',
        category: 'Discipline & Compliance',
        sub_parameter: 'Was any indiscipline, misconduct or inappropriate behaviour was reported on any of the Contractor employee in the said month?',
        input_options: [{ option: 'Yes', score: 0 }, { option: 'No', score: 4 }],
        score: 0,
        weight: 15,
        weighted_score: 0,
    },

];

const DisciplineFeedback = ({ updateScore, disabled, initialValues }) => {

    const updateData = (key, score) => {
        let count = 0
        let updateData = data.map(item => {
            if (item.key == key) {
                item.score = score
                item.weighted_score = (score * item.weight) / 100
            }
            count = count + item.weighted_score
            return item;
        })
        setWeightedScore(count)
        setData(updateData)
        updateScore("Discipline & Compliance", updateData)
    }
    const [weightedScore, setWeightedScore] = useState(0)


    const [data, setData] = useState(() => {
        let count = 0;
        let updatedParameters = parameters.map(item => {
            item.updateFunction = updateData
            item.disabled = disabled
            if (initialValues) {
                let option = initialValues.scores.filter(x => x.key == item.key)
                if (option.length > 0) {
                    item.selected_option = option[0].selected_option
                    item.score = option[0].score
                    item.weighted_score = option[0].weighted_score
                    count += option[0].weighted_score
                } else {
                    item.selected_option = ""
                }
            }
            return item;
        })
        setWeightedScore(count)
        return updatedParameters;
    });


    return (
        <>
            {!disabled && <>
                <div style={{ padding: "10px", float: "right", marginRight: "15px", background: "white", border: "1px solid lightgray", borderRadius: "10px" }}>
                    <Statistic
                        title="Overall Discipline & Compliance"
                        valueStyle={{ color: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                        prefix={weightedScore < 3 ? <DislikeOutlined /> : <LikeOutlined />}
                        value={weightedScore}
                        precision={2} />
                </div>
                <br /><br /><br /><br /></>}
            <div className='form-box' >
                {(initialValues.scores.some(obj => obj.category === 'Discipline & Compliance')) ?
                    <div className='score-legend' 
                    style={{ background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}>
                        <p style={{ margin: "0px" }}>Overall Discipline & Compliance Score - {weightedScore.toFixed(2)}</p>
                    </div> :
                    <div className='score-legend' style={{ background: '#838383' }}>
                        <p style={{ margin: "0px" }}>Discipline & Compliance Feedback Pending</p>
                    </div>}
                <Table
                    bordered={true}
                    columns={columns}
                    pagination={false}
                    size="small"
                    dataSource={_.cloneDeep(data)} />


            </div>

        </>
    );
}
export default DisciplineFeedback;